import { jsx as t, Fragment as c } from "react/jsx-runtime";
import { useState as d, useEffect as m, createElement as p } from "react";
import { classes as f } from "../../utils/helpers.js";
import { slideLayoutsMap as h } from "../../settings.js";
import '../../assets/CarouselSlide.css';const g = "_slide_gx8qn_1", i = {
  slide: g,
  "slide--variable-height": "_slide--variable-height_gx8qn_17"
};
function v({
  slide: e,
  index: l,
  currentIndex: r,
  variableHeight: s = !1
}) {
  const [a, o] = d(null);
  return m(() => {
    o(h.get(e.layout));
  }, [e]), /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t(
    "li",
    {
      className: f([
        i.slide,
        "slide",
        s ? i["slide--variable-height"] : ""
      ]),
      "aria-label": e.ariaLabel,
      "aria-roledescription": "carousel-item",
      inert: r !== l ? "" : null,
      "data-index": l,
      children: a !== null && e.cells.map((n, u) => /* @__PURE__ */ p(a, { ...n.props, key: `slide${l}-cell${u}` }))
    }
  ) });
}
export {
  v as CarouselSlide,
  v as default
};
